import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../translate';
import AgendaEvent from '../components/AgendaEvent';

const getDate = date => moment(date).format('DD MMM, YYYY');
const getTime = date => moment(date).format('HH:mm');

const checkEventStatus = event => {
  const now = new Date(); // Current time

  // Convert event start and end times to Date objects
  const startTime = new Date(event.startDate);
  const endTime = new Date(event.endDate);

  if (event?.status === 'canceled') {
    return 'canceled';
  }

  // Check if the event is ongoing, in the past, or in the future
  if (now >= startTime && now <= endTime) {
    return 'ongoing'; // Event is currently happening
  }
  if (now < startTime) {
    return 'future'; // Event is in the future
  }
  return 'past'; // Event is in the past
};

function CalendlyPopover(props) {
  const { event: agendaEvent } = props;
  const { event } = agendaEvent?.title?.props || {};
  return (
    <div className="calendly-popover">
      <div className={`event-${checkEventStatus(event)}`}>
        <AgendaEvent event={event} />
      </div>
      <div className="time-wrapper">
        <div className="start-date-wrapper">
          <i className="la la-clock-o" />
          <span className="date">{getDate(event.startDate)}</span>
          <span className="time">{getTime(event.startDate)}</span>
        </div>
        <div className="end-date-wrapper">
          <div className="placeholder" />
          <span className="date">{getDate(event.endDate)}</span>
          <span className="time">{getTime(event.endDate)}</span>
        </div>
      </div>
    </div>
  );
}

CalendlyPopover.propTypes = {
  event: PropTypes.shape({
    title: {
      props: {
        event: {
          end: PropTypes.string,
          start: PropTypes.string,
        },
      },
    },
  }).isRequired,
};

export default translate(CalendlyPopover);
